/**
 * Complimentary rewards on a trip (founder, 2026-10-25): something the team
 * arranges for a customer besides a cabin upgrade (the separate "Upgraded"
 * toggle), such as priority boarding or a lounge pass. An admin turns on
 * "Rewarded" in Flight Details → Edit, picks a category and types the
 * airline's own name for it ("United Premier Access").
 *
 * Stored on the booking as flight_data.complimentary_rewards:
 *   [{ id, category, name, added_at }]
 * The customer sees it on the trip page and the Trips list, and is emailed
 * the first time each one is added (server/trip-reward-email.js).
 */
export const TRIP_REWARDS_FIELD = 'complimentary_rewards';

export const TRIP_REWARD_CATEGORIES = Object.freeze([
  { id: 'priority_boarding', label: 'Priority boarding', example: 'e.g., United Premier Access' },
  { id: 'extra_legroom', label: 'Extra legroom seat', example: 'e.g., Delta Comfort, Main Cabin Extra' },
  { id: 'seat_selection', label: 'Seat selection', example: 'e.g., Preferred seat' },
  { id: 'checked_bag', label: 'Checked bag', example: 'e.g., First checked bag' },
  { id: 'lounge_access', label: 'Lounge access', example: 'e.g., United Club one-time pass' },
  { id: 'wifi', label: 'Wi-Fi', example: 'e.g., Delta Wi-Fi flight pass' },
  { id: 'food_drink', label: 'Food and drinks', example: 'e.g., Onboard meal and drinks' },
  { id: 'other', label: 'Other', example: 'Name it as the airline does' },
]);
